import type { MergerAndAquisition } from '@pn/core/domain/intel/intel-data';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { store } from 'src/application/storage/store';
import { mergersAndAcquisitionsSlice } from './mergersAndAcquisitionsSlice';

export const useMergersAndAcquisitionsStorage = () => {
  const { name, getInitialState } = mergersAndAcquisitionsSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isFetching: useSliceSelector((state) => state.isFetching),
    isError: useSliceSelector((state) => state.isError),
    mergersAndAcquisitions: useSliceSelector(
      (state) => state.mergersAndAcquisitions
    ),
  };
};

export const mergersAndAcquisitionsActions = () => {
  const { dispatch, getState } = store;
  const { actions, name } = mergersAndAcquisitionsSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    request: () => dispatch(actions.request()),
    receive: (mergersAndAcquisitions: MergerAndAquisition[]) =>
      dispatch(actions.receive(mergersAndAcquisitions)),
    error: () => dispatch(actions.error()),
    reset: () => dispatch(actions.reset()),
  };
};
